import { css } from '@emotion/react';

const pickerWidth = 44 * 7;
const panelsWidth = pickerWidth + 20;

export default css`
  .ant-select .ant-select-arrow {
    .anticon {
      color: #546D49;
    }
  }
  .ant-btn-primary, .ant-btn-primary:hover, .ant-btn-primary:focus {
    background-color: #546D49;
    border-color: #546D49;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: bold;
  }
  .ant-btn-primary[disabled], .ant-btn-primary[disabled]:hover, .ant-btn-primary[disabled]:focus {
    background-color: #d7dbd4;
    border-color: #c6cac3;
  }
  .ant-form {
    .ant-form-item-label > label {
      font-weight: bold;
    }
    .ant-form-vertical .ant-form-item-label {
      padding-bottom: 5px;
    }
    .ant-input {
      border-radius: 5px;
    }
    .ant-select .ant-select-selector {
      border-radius: 5px;
    }
  }
  .ant-picker {
    border-radius: 5px;
  }
  .ant-modal-content {
    border-radius: 8px;
    .ant-modal-footer {
      padding: 32px 24px;
      padding-top: 0;
      border-top: none;
      .ant-btn + .ant-btn {
        margin-left: 12px;
      }
    }
  }
  .ant-picker-dropdown-range.narrow-picker {
    & .ant-picker-panels {
      width: ${panelsWidth}px;
      flex-wrap: wrap;
    }
    & .ant-picker-date-panel {
      width: ${panelsWidth}px;
      .ant-picker-header > button {
        min-width: 2.4em;
      }
      .ant-picker-body {
        padding: 0px 10px;
      }
      .ant-picker-content {
        width: ${pickerWidth}px;
        .ant-picker-cell {
          padding: 2px 0;
        }
      }
    }
  }
`;
